<details-card [title]="'simulationBuilder.TRANSCRIPT_PROMPT_TITLE' | transloco">
  <div content class="container" *ngIf="cleanTranscriptPromptGroup" [formGroup]="cleanTranscriptPromptGroup">
    <qai-field [label]="'simulationBuilder.TRANSCRIPT_PROMPT_FIELD_LABEL' | transloco">
      <textarea
        qai-textarea
        qaiPasteClean
        qaiTrimLeading
        formControlName="promptText"
      ></textarea>
    </qai-field>
  </div>
</details-card>
